import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useSelector } from "react-redux";
import ExchangeIcon from "./ExcangeIcon";

export const EXCHANGE_SELECTION_TILE_SIZE = 44;
export const EXCHANGE_SELECTION_ICON_SIZE = 36;
export const EXCHANGE_SELECTION_TILE_SIZE_LG = 66;
export const EXCHANGE_SELECTION_ICON_SIZE_LG = 54;

export const getExchangeSelectionGridSx = (tileSize = EXCHANGE_SELECTION_TILE_SIZE) => ({
    display: "grid",
    gridTemplateColumns: `repeat(auto-fill, ${tileSize}px)`,
    gap: 1,
    justifyContent: "center",
});

export const exchangeSelectionGridSx = getExchangeSelectionGridSx();

export const getExchangeSelectionTileSx = (selected, tileSize = EXCHANGE_SELECTION_TILE_SIZE) => ({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
    width: tileSize,
    height: tileSize,
    p: 0.25,
    borderRadius: 1.5,
    border: "1.5px solid",
    borderColor: selected ? "#95F205" : "rgba(255,255,255,0.2)",
    bgcolor: selected ? "rgba(149, 242, 5, 0.12)" : "rgba(255,255,255,0.04)",
    cursor: "pointer",
    overflow: "visible",
    transition: "border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
        borderColor: selected ? "#95F205" : "rgba(149, 242, 5, 0.45)",
        bgcolor: selected ? "rgba(149, 242, 5, 0.18)" : "rgba(149, 242, 5, 0.06)",
    },
    "&:focus": {
        outline: "none",
    },
    "&:focus-visible": {
        outline: "none",
        boxShadow: "0 0 0 2px rgba(149, 242, 5, 0.35)",
    },
});

export const exchangeSelectionTileSx = (selected) => getExchangeSelectionTileSx(selected);

const ExchangeSelectionTile = ({
    name,
    selected,
    onToggle,
    inputRole = 'checkbox',
    tileSize = EXCHANGE_SELECTION_TILE_SIZE,
    iconSize = EXCHANGE_SELECTION_ICON_SIZE,
}) => {
    const exchanges = useSelector((state) => state.crypto.exchanges);
    const hasImage = Boolean(exchanges[name]?.img);

    return (
        <Box
            component="button"
            type="button"
            role={inputRole}
            aria-checked={selected}
            aria-label={name}
            onClick={() => onToggle(name)}
            sx={getExchangeSelectionTileSx(selected, tileSize)}
        >
            {selected && (
                <CheckCircleIcon
                    sx={{
                        position: "absolute",
                        top: 1,
                        right: 1,
                        fontSize: tileSize > EXCHANGE_SELECTION_TILE_SIZE ? 14 : 12,
                        color: "#95F205",
                    }}
                />
            )}
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -58%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 0,
                }}
            >
                {hasImage ? (
                    <ExchangeIcon name={name} size={iconSize} isLink={false} compact />
                ) : (
                    <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: iconSize > EXCHANGE_SELECTION_ICON_SIZE ? 22 : 18 }}>
                        {name.slice(0, 2)}
                    </Typography>
                )}
            </Box>
            <Typography
                sx={{
                    color: selected ? "#95F205" : "rgba(255,255,255,0.85)",
                    fontSize: tileSize > EXCHANGE_SELECTION_TILE_SIZE ? 9 : 7,
                    fontWeight: selected ? 700 : 500,
                    textAlign: "center",
                    lineHeight: 1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "100%",
                    px: 0.25,
                }}
            >
                {name}
            </Typography>
        </Box>
    );
};

export default ExchangeSelectionTile;
